import { render, staticRenderFns } from "./customPropertiesComponent.vue?vue&type=template&id=b0e69a90&"
import script from "./customPropertiesComponent.vue?vue&type=script&lang=js&"
export * from "./customPropertiesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports